import { IS_NEW_BACKEND_API, mapKeysToCamelCase } from '@skytech/utils'

import { filterAndSortOptions } from '@/modules/admin/assets/helpers'
import { API_ROUTE_ADMIN_ASSETS_LEASED, API_ROUTE_ADMIN_ASSETS_NEW } from '@/resources/api-routes'
import { get } from '@/util/auth'

import { buildAssetFilterParams, type AssetFilters } from './getAssetCount'
import type { LeasedAssetOrigin, AssetOriginal } from './types'

type LeasedOriginal = {
  assets: LeasedAssetOrigin[]
  activeEndingOptions: string[]
}

export async function getAssetListWithFilters(filters: AssetFilters = {}) {
  const searchParams = buildAssetFilterParams(filters)
  const query = searchParams.toString()
  const path = query ? `${API_ROUTE_ADMIN_ASSETS_NEW}?${query}` : API_ROUTE_ADMIN_ASSETS_NEW

  const response = await get<{
    assets: AssetOriginal[]
    activeEndingOptions: string[]
  }>(path, IS_NEW_BACKEND_API)

  return {
    assets: response.assets,
    activeEndingOptions: filterAndSortOptions(response.activeEndingOptions),
  }
}

// deprecated
export async function getLeasedAssetList() {
  const response = await get<LeasedOriginal>(API_ROUTE_ADMIN_ASSETS_LEASED)
  const assets = {
    assets: response.assets,
    activeEndingOptions: filterAndSortOptions(response.activeEndingOptions),
  }
  const camelCaseAssets = mapKeysToCamelCase(assets)
  return camelCaseAssets
}
